import useSWRMutationForm, { useErrorToSnackbar } from 'common-form/useSWRMutationForm';
import usePrequalUpdate from '../../resources/prequal/usePrequalUpdate';
import { COULD_NOT_VERIFY_ADDRESS } from '../../constants';

const errorSchema = {
  [COULD_NOT_VERIFY_ADDRESS]: {
    street: ['The address provided could not be verified. It must be your personal residence. PO Boxes and commercial addresses are not permitted.'],
    city: [''],
    state: [''],
    zipCode: [''],
  },
};

const useForm = () => useSWRMutationForm({
  useMutation: usePrequalUpdate,
  errorSchema,
  useUnhandledError: useErrorToSnackbar,
});

export default useForm;
